export enum SnackbarMessageType {
  PO_SUBMIT_SUCCESS = 'PO_SUBMIT_SUCCESS',
  GENERIC_MESSAGE = 'GENERIC_MESSAGE'
}
